import SideView from './side-view.vue';

export default SideView;



// WEBPACK FOOTER //
// ./src/components/side-view/index.js